/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export default {
  command_intelligence_drawer_title: 'Command Intelligence',
  command_intelligence_drawer_resize_handle: 'Ziehen, um das Panel zu vergrößern',
  command_intelligence_close_aria: 'Assistent schließen',
  command_intelligence_send_aria: 'Nachricht senden',
  command_intelligence_stop_aria: 'Antwort stoppen',
  command_intelligence_composer_input_aria: 'Nachricht an Command Intelligence',
  command_intelligence_drawer_more_options: 'Weitere Optionen',
  command_intelligence_dock_position: 'Andockposition',
  command_intelligence_dock_left: 'Links',
  command_intelligence_dock_right: 'Rechts',
  command_intelligence_dock_top: 'Oben',
  command_intelligence_dock_bottom: 'Unten',
  command_intelligence_panel_layout: 'Panel-Layout',
  command_intelligence_panel_layout_overlap: 'Inhalt überlagern',
  command_intelligence_panel_layout_push: 'Inhalt verschieben',
  command_intelligence_panel_auto_hide_overlap: 'Beim Klicken außerhalb automatisch ausblenden',
  command_intelligence_session_reset: 'Unterhaltung zurücksetzen',
  command_intelligence_try_one_of_these: 'Probieren Sie eines davon',
  command_intelligence_attach_hint: 'Fügen Sie Kontextelemente hinzu, um Fragen zu stellen.',
  command_intelligence_welcome_subhead: 'Stellen Sie eine Frage, um zu beginnen.',
  command_intelligence_attach_modal_title: 'Kontext anhängen',
  command_intelligence_attach_modal_subtitle:
    'Wählen Sie Elemente aus dieser Ansicht. Bereits angehängte Elemente sind ausgegraut.',
  command_intelligence_attach_modal_search_placeholder: 'Suchen…',
  command_intelligence_attach_modal_pool:
    '{count, plural, one {# Element verfügbar} other {# Elemente verfügbar}} · {selected} ausgewählt',
  command_intelligence_attach_modal_empty: 'Nichts zum Anhängen verfügbar',
  command_intelligence_attach_modal_no_results: 'Keine Elemente entsprechen Ihrer Suche',
  command_intelligence_context_bar_attached_section: 'Angehängt ({count})',
  command_intelligence_context_bar_clear_attached: 'Löschen',
  command_intelligence_context_bar_add: 'Kontext anhängen',
  command_intelligence_placeholder_ready: 'Stellen Sie eine Frage…',
  command_intelligence_placeholder_attach: 'Kontext anhängen, um eine Frage zu stellen…',
  command_intelligence_composer_submit_hint: 'Eingabe zum Senden · Umschalt+Eingabe für neue Zeile',
  command_intelligence_composer_stop_hint: 'Stoppen · nächste Nachricht während des Wartens entwerfen',
  command_intelligence_response_stopped: 'Antwort gestoppt',
  command_intelligence_generation_in_progress: 'Ihre Frage wird bearbeitet',
  command_intelligence_generation_trace_title: 'Durchgeführte Schritte',
  command_intelligence_generation_trace_toggle: 'Schritte anzeigen',
  command_intelligence_generation_trace_summary: '{completed} von {total} Schritten abgeschlossen',
  command_intelligence_generation_trace_summary_generic: 'Generierungsschritte',
  command_intelligence_generation_tool_count: '{count, plural, one {# Tool} other {# Tools}}',
  command_intelligence_generation_turn_label: 'Runde {turn} von {total}',
  command_intelligence_generation_turn_completed: 'Runde {turn} von {total} abgeschlossen',
  command_intelligence_generation_turn_completed_elapsed:
    'Runde {turn} von {total} abgeschlossen ({seconds}s vergangen)',
  command_intelligence_generation_turn_completed_with_tools:
    'Runde {turn} von {total} abgeschlossen – {tools} verwendet',
  command_intelligence_generation_tools_used: '{tools} verwendet',
  command_intelligence_reasoning_thinking: 'Denke nach…',
  command_intelligence_reasoning_thought_for_seconds: '{seconds} Sekunden nachgedacht',
  command_intelligence_reasoning_waiting: 'Ihre Frage wird bearbeitet…',
  command_intelligence_attach_modal_done: 'Fertig',
  command_intelligence_attach_modal_attached_badge: 'angehängt',
  command_intelligence_attach_modal_attach: 'Anhängen',
  command_intelligence_attach_modal_attach_count: 'Anhängen ({count})',
  command_intelligence_attach_modal_close_aria: 'Auswahl schließen',
  command_intelligence_session_limit_context:
    'Kontextlimit erreicht. Setzen Sie die Unterhaltung zurück, um fortzufahren.',
  command_intelligence_session_limit_prompt:
    'Nachrichtenlimit erreicht. Setzen Sie die Unterhaltung zurück, um fortzufahren.',
  command_intelligence_suggested_followups: 'Vorgeschlagene Folgefragen',
  command_intelligence_credit_warning_line: '{pct}% der monatlichen KI-Guthaben für {scope} verbraucht',
  command_intelligence_tooltip_prompts: '{count} von {max} Nachrichten ({pct}%)',
  command_intelligence_tooltip_context: '{used} von {max} Kontext-Token ({pct}%)',
  command_intelligence_tooltip_context_idle: 'Kontextnutzung erscheint nach der ersten Antwort',
  command_intelligence_credits_loading: 'Guthaben wird geladen…',
  command_intelligence_credits_unavailable: 'Guthaben nicht verfügbar',
  command_intelligence_credits_tooltip: 'Monatliche KI-Guthaben für {monthKey}',
  command_intelligence_credits_tooltip_short: 'Monatliche KI-Guthaben',
  command_intelligence_credits_scope_profile: 'Profil',
  command_intelligence_credits_scope_entity: 'Entität',
  command_intelligence_credits_used_of_cap: '{used} von {cap} Guthaben',
  command_intelligence_credits_used_no_cap: '{used} Guthaben verbraucht',
  command_intelligence_credits_monthly_title: 'Monatliche KI-Guthaben',
  command_intelligence_compare_aria: 'Agenten vergleichen',
  command_intelligence_compare_tooltip: 'Dieselbe Frage mit mehreren Agentenprofilen ausführen',
  command_intelligence_compare_cancelled: 'Vergleich abgebrochen',
  command_intelligence_compare_branch_failed: 'Vergleichszweig fehlgeschlagen',
  command_intelligence_compare_title: 'Agentenvergleich',
  command_intelligence_compare_stats: '{durationMs} ms · {model} · {inTok} ein / {outTok} aus · {agentRef}',
  command_intelligence_compare_error: '{message}',
  command_intelligence_profile_agent: '{agentRef}',
  command_intelligence_feedback_good_response: 'Gute Antwort',
  command_intelligence_feedback_bad_response: 'Schlechte Antwort',
  command_intelligence_feedback_dialog_title: 'Feedback geben',
  command_intelligence_feedback_dialog_body:
    'Helfen Sie uns, uns zu verbessern, indem Sie Feedback zu dieser Antwort geben. Ihr Feedback wird an unser Betriebsteam gesendet.',
  command_intelligence_feedback_response_label: 'Antwort',
  command_intelligence_feedback_input_label: 'Ihr Feedback (optional)',
  command_intelligence_feedback_input_placeholder: 'Was war an dieser Antwort falsch oder nicht hilfreich?',
  command_intelligence_feedback_submit: 'Feedback senden',
  command_intelligence_feedback_submit_error: 'Feedback konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
  command_intelligence_feedback_question_understanding: 'Hat der Agent verstanden, was Sie wollten?',
  command_intelligence_feedback_question_readability: 'War die Antwort leicht zu lesen und zu nutzen?',
  command_intelligence_feedback_section_understanding: 'Verständnis',
  command_intelligence_feedback_section_readability: 'Lesbarkeit',
  command_intelligence_feedback_choice_none: 'Keine',
  command_intelligence_feedback_choice_misunderstood_task: 'Aufgabe missverstanden',
  command_intelligence_feedback_choice_ignored_constraint: 'Einschränkung ignoriert',
  command_intelligence_feedback_choice_wrong_scope: 'Falscher Umfang',
  command_intelligence_feedback_choice_visually_hard_to_read: 'Visuell schwer lesbar',
  command_intelligence_feedback_choice_wrote_too_much: 'Zu viel geschrieben',
  command_intelligence_feedback_choice_explanation_not_trustworthy: 'Erklärung nicht vertrauenswürdig',
  command_intelligence_copy_aria: 'In Zwischenablage kopieren',
  command_intelligence_error_missing_invoke_permission:
    'Sie haben keine Berechtigung, Command Intelligence für diesen Agenten zu verwenden. Bitten Sie Ihren Administrator, die erforderlichen Intelligence-Berechtigungen zu gewähren (z. B. Analyst).',
  command_intelligence_access_denied_title: 'Zugriff erforderlich',
  command_intelligence_error_session_expired:
    'Ihre Sitzung ist abgelaufen. Bitte aktualisieren Sie die Seite und melden Sie sich erneut an.',
};
